import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill-rule="evenodd" clip-rule="evenodd" d="M9.792 3.577c-.595 0-1.077.483-1.077 1.078v6.381h2.154V4.655c0-.595-.482-1.078-1.077-1.078Zm.808 8.536H8.984v1.616H10.6v-1.616Zm1.076 1.616a.539.539 0 0 1 0 1.078H10.33v.269a1.346 1.346 0 1 0 2.693 0v-2.238a.539.539 0 1 1 1.077 0v2.238a2.423 2.423 0 1 1-4.847 0v-.27H7.907a.539.539 0 0 1 0-1.077v-1.616h-.269a.539.539 0 0 1 0-1.077V4.655a2.154 2.154 0 1 1 4.308 0v6.381a.539.539 0 0 1 0 1.077h-.27v1.616Z" fill="currentColor" />' }
  })
);